import { useRef, useState, useLayoutEffect } from "react";

export const useComponentHeight = (...deps:any[]) => {
    const ref = useRef<HTMLElement|null>(null);
    const [height, setHeight] = useState(0);
    const [offsetHeight, setOffsetHeight] = useState(0);
    // info('userComponentHeight', height)
    useLayoutEffect(() => {
      // info('useLayoutEffect',deps, ref.current?.getBoundingClientRect(), ref.current?.getClientRects())
      const { height = -1 } = ref.current?.getBoundingClientRect() ?? {};
      setOffsetHeight(ref.current?.offsetHeight ?? -1);
      // info('height layout', height);
      setHeight(height);
      return () => {
        // info('useLayoutEffect return')
        setHeight(-1);
      }
    }, [...deps]);

    return {
        ref,
        height,
        offsetHeight
    }
}